
import React from 'react';
import { ShieldCheck, Wrench, ArrowRight } from 'lucide-react';

const RiskReversal: React.FC = () => {
  return (
    <section className="py-24 bg-[#0F1419]">
      <div className="max-w-5xl mx-auto px-4">
        <div className="relative p-1 bg-gradient-to-br from-[#1A4D2E] via-[#FF6B35] to-[#4E3629] rounded-[4rem] shadow-2xl">
          <div className="bg-[#0F1419] rounded-[3.8rem] p-8 md:p-20 text-center relative overflow-hidden">
            {/* Subtle background icon */}
            <div className="absolute inset-0 opacity-5 pointer-events-none flex items-center justify-center">
              <ShieldCheck className="w-96 h-96 text-white" />
            </div>

            <div className="relative z-10">
              <div className="inline-flex items-center justify-center w-24 h-24 bg-[#1A4D2E] text-white rounded-3xl mb-10 shadow-2xl shadow-green-900/50 transform -rotate-3 group-hover:rotate-0 transition-transform">
                <ShieldCheck className="w-12 h-12 text-[#FF6B35]" />
              </div>
              
              <h2 className="text-4xl md:text-7xl font-black mb-10 uppercase tracking-tighter italic text-white leading-none">
                The "3-Job" <br />Ironclad Guarantee
              </h2>
              
              <div className="max-w-3xl mx-auto space-y-8 text-xl text-gray-300 leading-relaxed font-bold italic">
                <p>
                  Most marketing companies want your money upfront and offer "best efforts." <span className="text-[#FF6B35] uppercase tracking-widest not-italic">That’s BS.</span>
                </p>
                <p>
                  If you use Arbor Advantage for 30 days and you don’t book <span className="text-white underline decoration-[#1A4D2E] decoration-4">at least 3 jobs</span> directly through our automation that you otherwise would have missed... 
                </p>
                <div className="text-2xl md:text-4xl font-black text-white py-8 px-6 bg-white/5 rounded-[2rem] border-2 border-white/10 shadow-inner">
                  I will refund every penny you paid AND pay for your next <span className="text-[#FF6B35]">tank of diesel</span> for your chipper truck.
                </div>
                <p>
                  No hoops. No "let us try one more thing." Just a handshake and your money back.
                </p>
              </div>

              <div className="mt-16 flex flex-col md:flex-row items-center justify-center gap-6">
                <div className="flex items-center gap-4 bg-[#1A4D2E]/20 px-8 py-6 rounded-2xl border-2 border-[#1A4D2E]/30">
                  <Wrench className="w-8 h-8 text-[#FF6B35]" />
                  <div className="text-left">
                    <p className="text-xs font-black text-[#FF6B35] uppercase tracking-widest">Bonus Safety Net</p>
                    <p className="text-sm font-black text-white uppercase tracking-tight">We'll build your first 3 campaigns FOR YOU.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RiskReversal;
